var render = function (_h,_vm) {
var _obj;
var _c=_vm._c;return _c('div',{staticClass:"banner",class:( _obj = {}, _obj[(_vm.props.type || 'standard') + '-banner'] = !!_vm.props.type, _obj )},[_c('div',{staticClass:"container mx-width"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }